module.exports = __webpack_public_path__ + "static/media/studio-step2@3x.9eba288f.webp";